/**
 * 画面側のテーマ状態。純粋ロジックは src/lib/theme、ここは DOM と localStorage を渡すだけ。
 */
import { applyTheme, initialTheme, writeTheme, type ThemePreference } from '../lib/theme';

function safeLocalStorage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

const state = $state<{ pref: ThemePreference }>({ pref: 'system' });

export const theme = {
  get pref(): ThemePreference {
    return state.pref;
  },
  /** 起動時に 1 回。URL の ?theme= → 保存値 → OS の順で決めて <html> に付ける */
  init(root: Element = document.documentElement, search: string = location.search): void {
    state.pref = initialTheme(safeLocalStorage(), search);
    applyTheme(root, state.pref);
  },
  /** 設定画面から。保存できたら true */
  set(pref: ThemePreference, root: Element = document.documentElement): boolean {
    state.pref = pref;
    applyTheme(root, pref);
    return writeTheme(safeLocalStorage(), pref);
  },
};
